import React, {useEffect} from 'react';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';

import Claim from './components/claim/Claim.jsx';
import List from './components/list/List.jsx';
import Contact from './components/contact/Contact.jsx';
import Faqs from './components/faqs/Faqs.jsx';
import Policies from './components/policies/Policies.jsx';
import Account from './components/account/Account.jsx';
import Mint from './components/mint/Mint.jsx';
import Home from './components/home/Home.jsx';
import Players from './components/players/Players.jsx';
import Signup from './components/signup/Signup.jsx';
import Char2Bytes from './components/char2Bytes/Char2Bytes.jsx';

import {
    getNFTs, 
    //getUserMarketNftsLiveById
} from './utils/wallet';
import Navbarz from './components/navbar/Navbar.jsx';
import {useDispatch, useSelector} from 'react-redux';
import {selectLoaded, setStorage} from './store/reducers/storage.js';
import Gallery from './components/gallery/Gallery.jsx';
import Marketplace from './components/market/Market.jsx';
import GalleryItem from './components/gallery/GalleryItem.jsx';
import Footer from './components/footer/Footer';
import Marketplace2 from './components/market2/Market2.jsx';
import MarketItem1 from './components/market/MarketItem1';
import MarketItem2 from './components/market2/MarketItem2';

const App = () => {
    const loaded = useSelector(selectLoaded);
    const dispatch = useDispatch();
    useEffect(() => {
        try {
            const func = async () => {
                const nfts = await getNFTs();
                dispatch(setStorage(nfts));
            };
            if (!loaded) {
                func();
            }
        } catch (err) {
            console.log(err);
        }
    }, [dispatch, loaded]);

    return (
        <div style={{backgroundColor:'black'}}>
            <Router>
                <Navbarz />
                <Switch>
                    <Route exact component={Char2Bytes} path="/char2Bytes" />
                    <Route exact component={List} path="/list" />
                    <Route exact component={Faqs} path="/faqs" />
                    <Route exact component={Policies} path="/policies" />
                    <Route exact component={Mint} path="/mint" />
                    <Route exact component={Signup} path="/signup" />
                    <Route exact component={Claim} path="/claim" />
                    <Route exact component={Account} path="/account" />
                    <Route exact component={Players} path="/players" />
                    <Route exact component={Gallery} path="/gallery" />
                    <Route exact component={Marketplace} path="/nightmares" />
                    <Route exact component={Marketplace2} path="/market" />
                    <Route exact component={GalleryItem} path="/test" />

                    <Route exact path="/gallery/:id" render={({ match }) => {
                     // no await 
                     const itemId = String(match.params.id);
                     return (<GalleryItem itemId={itemId} />)}} />

                     <Route exact path="/nightmares/:id" render={({ match }) => {
                     // no await 
                     const itemId = String(match.params.id);
                     return (<MarketItem1 itemId={itemId} />)}} />

                     <Route exact path="/market/:id" render={({ match }) => {
                     // no await 
                     const itemId = String(match.params.id);
                     return (<MarketItem2 itemId={itemId} />)}} />



                    <Route exact component={Home} path="/" />
                    <Route exact component={Contact} path="/contact" />
                </Switch>
                <Footer />
            </Router>
        </div>
    );
};

export default App;
